export const commaFormat = number => number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

export const productItemsPluralizer = (number, word = "item", prefixWord = "") => {
  const itemsString = number > 1 ? `${word}s` : word;
  return `${commaFormat(number)} ${prefixWord} ${itemsString}`;
};
